import {useEffect, useMemo, useState} from 'react';
import {
    changeCardProductUser,
    checkoutProduct,
    getCardProductUser,
    removeCardProduct,
    getCartProductUser
} from "./services/customerCartService";
import {cartShowCount} from "../helpers/HeaderShow";

function CartController(props) {
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [listProduct, setListProduct] = useState([]);
    const [payProductIds, setPayProductId] = useState([]);

    const listEnable = useMemo(() => {
        return listProduct?.filter(prod => prod?.productSimilar?.id > 0);
    }, [listProduct])

    const fetchCartDataFromLocalStorage = (page, pageSize) => {
        let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
        let totalItems = cart.length;
        let totalPages = Math.ceil(totalItems / pageSize);
        let startIndex = (page - 1) * pageSize;
        let endIndex = startIndex + pageSize;
        let content = cart.slice(startIndex, endIndex);
        return {content, totalPages};
    };

    const fetchData = () => {
        const pageSize = 10;

        if (window.isLoggedin === "False") {
            const {content, totalPages} = fetchCartDataFromLocalStorage(1, pageSize);
            console.log(content, content.join(","))

            getCartProductUser("productSimilarId=" + content?.map(ct => ct.productSimilarId).join(","), (data) => {
                setListProduct(data?.map(item => {
                    const foundedCartItem = content.find(ct => ct.productSimilarId === item?.productSimilar?.id);
                    return {
                        nameCooperate: item?.cooperative?.name,
                        productSimilar: {
                            ...item.productSimilar
                        }, products: {
                            ...item.productSimilar?.product
                        },
                        quantity: foundedCartItem?.quantity,
                        type: foundedCartItem?.type
                    }
                }));
            }).then();
            setTotalPage(totalPages);

        } else {
            getCardProductUser({page: 1}, (rs) => {
                let {content, totalPage} = rs;
                setTotalPage(totalPage);
                setListProduct(content);
            });
        }
    };
    const fetchMoreData = () => {
        let nextPage = page + 1;
        if (nextPage > totalPage) return;

        setPage(nextPage);

        const pageSize = 10;

        if (window.isLoggedin === "False") {
            const {content} = fetchCartDataFromLocalStorage(nextPage, pageSize);
            getCartProductUser("productSimilarId=" + content?.map(ct => ct.productSimilarId).join(","), (data) => {
                setListProduct(prevList => [...prevList, ...data?.map(item => {
                    const foundedCartItem = content.find(ct => ct.productSimilarId === item?.productSimilar?.id);
                    return {
                        nameCooperate: item?.cooperative?.name,
                        productSimilar: {
                            ...item.productSimilar
                        }, products: {
                            ...item.productSimilar?.product
                        },
                        quantity: foundedCartItem?.quantity,
                        type: foundedCartItem?.type
                    }
                })]);
            }).then();
        } else {
            getCardProductUser({page: nextPage}, (rs) => {
                let {content, totalPage} = rs;
                setTotalPage(totalPage);
                setListProduct(prevList => [...prevList, ...content]);
            });
        }
    };


    const isLoadMore = useMemo(() => {
        return page < totalPage;
    }, [page, totalPage])

    useEffect(() => {
        fetchData();

    }, []);

    const changeQuantity = (productSimilarId) => {
        let index = listProduct.findIndex(product => product?.productSimilar?.id === productSimilarId);

        return function (event) {
            let quantity = event.target.value;
            if (quantity < 1) {
                toastr.error('Quý Khách hàng không thể giảm sản phẩm về 0!');
                return;
            }
            if (quantity > 1000) return;

            if (index > -1) {
                if (window.isLoggedin === "False") {
                    let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
                    let cartIndex = cart.findIndex(item => item?.productSimilarId === productSimilarId);

                    if (cartIndex > -1) {
                        cart[cartIndex].quantity = quantity;
                        localStorage.setItem("cart", JSON.stringify(cart));

                        let newList = [...listProduct];
                        newList[index].quantity = quantity;
                        setListProduct(newList);
                    }
                } else {
                    changeCardProductUser({productSimilarId: productSimilarId, Quantity: quantity}, function (res) {
                        if (res.statusCode === 200) {
                            let newList = [...listProduct];
                            newList[index].quantity = quantity;
                            setListProduct(newList);
                        } else {
                            toastr.error('Lỗi! ' + res?.err || '');
                        }
                    });
                }
            }
        };
    };

    const increaseDecreaseQuantity = (productSimilarId, number) => {
        let index = listProduct.findIndex(product => product?.productSimilar?.id === productSimilarId);

        return function () {
            if (index > -1) {
                let newList = [...listProduct];
                let quantity = parseInt(newList[index].quantity) + number;
                if (quantity < 1) {
                    toastr.error('Quý Khách hàng không thể giảm sản phẩm về 0!');
                    return;
                }
                if (quantity > 1000) return;

                if (window.isLoggedin === "False") {
                    let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
                    let cartIndex = cart.findIndex(item => item?.productSimilarId === productSimilarId);

                    if (cartIndex > -1) {
                        cart[cartIndex].quantity = quantity;
                        localStorage.setItem("cart", JSON.stringify(cart));

                        newList[index].quantity = quantity;
                        setListProduct(newList);
                    }
                } else {
                    changeCardProductUser({productSimilarId: productSimilarId, Quantity: quantity}, function (res) {
                        if (res.statusCode === 200) {
                            newList[index].quantity = quantity;
                            setListProduct(newList);
                        } else {
                            toastr.error('Lỗi! ' + res?.err || '');
                        }
                    });
                }
            }
        };
    };


    const removeProduct = (productSimilarId) => {
        return function () {
            if (window.isLoggedin === "False") {
                let cart = JSON.parse(localStorage.getItem("cart")) ?? [];
                let newCart = cart.filter(item => item?.productSimilarId !== productSimilarId);
                localStorage.setItem("cart", JSON.stringify(newCart));

                let index = listProduct.findIndex(product => product?.productSimilar?.id === productSimilarId);
                if (index > -1) {
                    let newList = [...listProduct];
                    newList.splice(index, 1);
                    let cartTotalItems = newList.length;
                    $(".cart-list").attr("data-count", cartTotalItems);
                    $("#cart-mobile").attr("data-count", cartTotalItems);
                    setListProduct(newList);
                    toastr.success('Xóa sản phẩm thành công!');
                }
            } else {
                removeCardProduct(productSimilarId, function () {
                    let index = listProduct.findIndex(product => product?.productSimilar?.id === productSimilarId);
                    if (index > -1) {
                        let newList = [...listProduct];
                        newList.splice(index, 1);
                        let cartTotalItems = newList.length;
                        $(".cart-list").attr("data-count", cartTotalItems);
                        $("#cart-mobile").attr("data-count", cartTotalItems);
                        setListProduct(newList);
                        toastr.success('Xóa sản phẩm thành công!');
                    }
                });
            }
        }
    };

    const clickAll = (event) => {
        if (event.target.checked) {
            setPayProductId(listEnable?.map(product => product?.productSimilar?.id))
        } else {
            setPayProductId([])
        }
    }

    const isCheckAll = () => {
        return payProductIds.length >= listEnable.length
    }

    const isChecked = (productSimilarId) => {
        return payProductIds.findIndex(value => value == productSimilarId) > -1
    }
    const productCheck = (event) => {
        let currentList = [...payProductIds];
        let productSimilarId = event.target.value;
        if (event.target.checked) {
            currentList.push(productSimilarId);
            setPayProductId(currentList)
        } else {
            let index = currentList.findIndex(value => value == productSimilarId);
            currentList.splice(index, 1);
            setPayProductId(currentList)
        }
    }


    const productPrice = (cartProduct) => {
        let quantityBy = (cartProduct?.quantity || 0);
        let price = (cartProduct?.productSimilar?.price || 0);
        let productRangePrice = cartProduct?.productRangePrice || [];
        if (Array.isArray(productRangePrice) && productRangePrice.length > 0) {
            let rangePrice = productRangePrice.findLast(item => item.minQuantity <= quantityBy && (!item.maxQuantity || item.maxQuantity >= quantityBy))
            if (rangePrice) {
                price = rangePrice.price;
            }
        }
        return price;
    }

    const totalProductPrice = (product) => {
        let price = productPrice(product);
        let quantity = product?.quantity || 0;

        return price * quantity
    }

    const totalPrice = useMemo(() => {
        let totalPrice = 0;
        for (let productSimilarId of payProductIds) {
            let product = listProduct.find(product => product?.productSimilar?.id == productSimilarId);
            if (product) {
                totalPrice += totalProductPrice(product);
            }
        }
        return totalPrice
    }, [listProduct, payProductIds])

    const checkout = () => {
        if (payProductIds.length < 1) {
            toastr.error('Vui lòng chọn sản phẩm cần mua!')
            return;
        }
        let productCheckouts = [];
        for (let productSimilarId of payProductIds) {
            let product = listProduct.find(product => product?.productSimilar?.id == productSimilarId);
            if (product) {
                productCheckouts.push({
                    productSimilarId: productSimilarId,
                    quantity: product?.quantity,
                })
            }
        }

        checkoutProduct({
            productCheckouts,
            isLogin: window.isLoggedin === "True"
        }, function (reponse) {
            if (reponse.statusCode !== 200) {
                if (reponse.data?.isReload) {
                    setPayProductId([]);
                    fetchData()
                }
                toastr.error(reponse.message ?? "Có lỗi xảy ra, thử lại sau!");
            } else {
                window.location.replace("/Users/Checkout?state=" + reponse.data);
            }
        })
    }

    const method = {
        changeQuantity,
        removeProduct,
        increaseDecreaseQuantity,
        productCheck,
        clickAll,
        isChecked,
        isCheckAll,
        checkout,
        fetchMoreData,
        productPrice,
        totalProductPrice,
    };

    return {method, state: {listProduct, isLoadMore, payProductIds, totalPrice}};
}

export default CartController;